export default __webpack_public_path__ + "images/9a0b58d881d91b3bff1eafabcdb2da97-holiday.webp";